
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProfileBasicInfoProps {
  nickname: string;
  preferredGame: string;
  setNickname: (value: string) => void;
  setPreferredGame: (value: string) => void;
}

export const ProfileBasicInfo = ({
  nickname,
  preferredGame,
  setNickname,
  setPreferredGame
}: ProfileBasicInfoProps) => {
  return (
    <Card className="bg-[#1A2233] border-[#222A35] text-white">
      <CardHeader>
        <CardTitle>Informações Básicas</CardTitle>
        <CardDescription className="text-gray-400">
          Atualize suas informações principais
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="nickname">Nome de Usuário</Label>
          <Input 
            id="nickname" 
            value={nickname} 
            onChange={(e) => setNickname(e.target.value)}
            className="bg-[#242C37] border-[#2A3749] text-white"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="game">Jogo Preferido</Label>
          <Input 
            id="game" 
            value={preferredGame} 
            onChange={(e) => setPreferredGame(e.target.value)}
            className="bg-[#242C37] border-[#2A3749] text-white"
          />
        </div>
      </CardContent>
    </Card>
  );
};
